import { ServiceContainer } from "@/services/backend/qpm/calculations/types/calculation";
import { Loader2 } from "lucide-react";
import t from "@/lang/lang";
import { AdditionalTimeComponent } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/_components/additional-time-component";
import { CalculationServiceType } from "@/services/backend/qpm/calculations/types/calculation-enum";
import { useCalculationData } from "@/services/backend/qpm/calculations/hooks/calculation-context";
import { ServiceTimeComponent } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/_components/service-time-component";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/shared/components/ui/tabs";
import { ServiceContainerResultComponent } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/_components/service-container-result-component";
import { ServiceGroupComponent } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/_components/service-group-component";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/shared/components/ui/accordion";

export type ServiceGroupsComponentProps = {
  calculationId: string;
  calculationServiceType: CalculationServiceType;
  serviceContainer?: ServiceContainer;
};

export function ServiceContainerComponent({
  calculationId,
  calculationServiceType,
  serviceContainer,
}: ServiceGroupsComponentProps) {
  const { calculation, isLoading } = useCalculationData();
  if (isLoading) {
    return <Loader2 className="animate-spin" />;
  }

  const displayServiceContainer = {
    ...serviceContainer,
    serviceGroups: serviceContainer?.serviceGroups ?? [],
    results: serviceContainer?.results ?? [],
    documentations: serviceContainer?.documentations ?? [],
    serviceParameters: serviceContainer?.serviceParameters ?? {},
    totalCost: serviceContainer?.totalCost ?? {},
    totalTimeDocumentation: serviceContainer?.totalTimeDocumentation ?? 0,
    totalTravelingTime: serviceContainer?.totalTravelingTime ?? 0,
    additionalTimePerMeasure: serviceContainer?.additionalTimePerMeasure ?? 0,
    additionalCostPerYear: serviceContainer?.additionalCostPerYear ?? 0,
    totalAdditionalTimeDuration:
      serviceContainer?.totalAdditionalTimeDuration ?? 0,
    targetRevenue: serviceContainer?.targetRevenue ?? 0,
    createdAt: serviceContainer?.createdAt ?? "",
  } as ServiceContainer;

  return (
    calculation && (
      <>
        <Accordion type="single" defaultValue="parameter" collapsible>
          <AccordionItem value="parameter">
            <AccordionTrigger className="bg-secondary rounded-none border-b px-4 font-bold uppercase">
              {t("Parameter")}
            </AccordionTrigger>
            <AccordionContent className="border-b">
              <AdditionalTimeComponent
                calculationId={calculationId}
                documentations={calculation.documentations ?? {}}
                serviceGroup={displayServiceContainer}
                serviceTypeKey={calculationServiceType}
              />
              <ServiceTimeComponent
                calculationId={calculationId}
                materialCost={calculation.materialCost ?? {}}
                monitorSnaps={calculation.monitorSnaps ?? {}}
                serviceGroup={displayServiceContainer}
                serviceTypeKey={calculationServiceType}
              />
            </AccordionContent>
          </AccordionItem>
        </Accordion>
        <div className="flex w-full flex-col">
          <Tabs defaultValue="service-results" className="w-full gap-0">
            <TabsList className="h-fit w-full rounded-none">
              <TabsTrigger
                value="service-results"
                className="rounded-sm text-lg"
              >
                {t("Ergebnisse")}
              </TabsTrigger>
              <TabsTrigger
                value="service-groups"
                className="rounded-sm text-lg"
              >
                {t("Service Gruppen")}
              </TabsTrigger>
            </TabsList>
            <TabsContent value="service-results">
              <ServiceContainerResultComponent
                results={displayServiceContainer.results}
                serviceTypeKey={calculationServiceType}
              />
            </TabsContent>
            <TabsContent value="service-groups">
              <ServiceGroupComponent
                serviceGroupList={displayServiceContainer}
              />
            </TabsContent>
          </Tabs>
        </div>
      </>
    )
  );
}
